import { FC, memo, useEffect, useRef, useState } from 'react';

import { DefaultImage, Preloader } from '@smartshell/ui-kit';
import cn from 'classnames';

import { imagePreloaderObserver } from 'services/ImagePreloader';

import s from './ApplicationCard.module.scss';
import { IApplicationCardProps, TLoadingStatus } from './interfaces';

export const ApplicationCard: FC<IApplicationCardProps> = memo(
  ({
    title,
    size = 'l',
    imagePath,
    isActive,
    onClick,
    onDoubleClick,
    onContextMenu,
    age,
  }) => {
    const [loadingStatus, setLoadingStatus] = useState<TLoadingStatus>(
      imagePath ? 'LOADING' : 'ERROR'
    );

    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
      if (containerRef.current) {
        imagePreloaderObserver.observe(containerRef.current);
      }

      return () => {
        if (containerRef.current) {
          imagePreloaderObserver.unobserve(containerRef.current);
        }
      };
    }, []);

    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
      <div
        className={cn(s.container, s[size], isActive && s.active)}
        onClick={onClick}
        onDoubleClick={onDoubleClick}
        onContextMenu={onContextMenu}
      >
        <div
          ref={containerRef}
          className={cn(s['image-container'], s[size], isActive && s.active)}
        >
          {age !== null && <div className={s.age}>{age}+</div>}
          <img
            className={cn(s.image, s[size], {
              [s.hidden]: loadingStatus !== 'SUCCESS',
            })}
            data-src={imagePath}
            alt={title}
            onLoad={() => setLoadingStatus('SUCCESS')}
            onError={() => {
              setLoadingStatus('ERROR');
            }}
          />
          {loadingStatus === 'LOADING' && <Preloader loading />}
          {loadingStatus === 'ERROR' && <DefaultImage isActive={isActive} />}
        </div>
        <span title={title} className={s.title}>
          {title}
        </span>
      </div>
    );
  }
);
